import React from "react";
import {useTranslation} from "react-i18next";
import FeatherIcon from "components/FeatherIcon";

const BookingTicketCreditChoiceHelpers = (props: {handleApplyToAll: () => void; openCreditCalculatorModal: () => void}) => {
    const {t} = useTranslation();
    return (
        <div className={"flex flex-col sm:flex-row gap-2 mt-2 mb-8 justify-around items-center"}>
            <button
                type={"button"}
                onClick={props.handleApplyToAll}
                className={
                    "w-full xs:w-auto flex items-center justify-center gap-2 rounded-full border border-black bg-white  px-3 py-2.5 text-xs font-semibold text-black hover:border-black/70 transition-colors"
                }
            >
                <FeatherIcon name={"copy"} className={"size-4 flex-none"} />
                <span>{t("Take over for everyone")}</span>
            </button>

            <button
                type={"button"}
                onClick={props.openCreditCalculatorModal}
                className={
                    "w-full xs:w-auto flex items-center justify-center gap-2 rounded-full border border-arbo-red bg-white px-3 py-2.5 text-xs font-semibold text-arbo-red hover:border-black/70 transition-colors"
                }
            >
                <FeatherIcon name={"info"} className={"size-4 flex-none"} />
                <span>{t("How many credits do I need?")}</span>
            </button>
        </div>
    );
};

export default BookingTicketCreditChoiceHelpers;
